import { Component, OnInit, Input,ViewEncapsulation } from '@angular/core';
import { PortalInfo } from "app/shared/services/portal-info";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";
declare var $:JQueryStatic;
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import {NgZone, Renderer, ElementRef, ViewChild} from '@angular/core';
// import {MdProgressBarModule} from '@angular/material';


@Component({
  selector: 'emi-top-nav',
  templateUrl: './emi-nav.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./emi-nav.component.css']
})
export class EmiNavComponent implements OnInit {
 

  portalInfo;
  menu;
  toggle:boolean=false;
  domainurl =  emiGlobals._emisubdomainUrl;
  closeResult: string;
  show_nav:boolean=false;

  constructor(
    private router:Router,
    private modalService: NgbModal,
    private baseInfoService:EmiBaseInfoService,
    private ngZone: NgZone,
    private renderer: Renderer
  ) {



  // Instead of holding a boolean value for whether the spinner
  // should show or not, we store a reference to the spinner element,
  // see template snippet below this script

    router.events.subscribe((event: RouterEvent) => {
      this._navigationInterceptor(event)
    })

    this.getPortalInfo();
    baseInfoService.portalDataFetched$.subscribe(
    data => {
      this.getPortalInfo();
    });
  }



   ngOnInit(): void {}




  open(content) {
    this.modalService.open(content, { windowClass: 'emi-contact' });
  }

    @ViewChild('spinnerElement')
  spinnerElement: ElementRef



  // Shows and hides the loading spinner during RouterEvent changes
  private _navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      // We wanna run this function outside of Angular's zone to
      // bypass change detection
      this.ngZone.runOutsideAngular(() => {
        // For simplicity we are going to turn opacity on / off
        // you could add/remove a class for more advanced styling
        // and enter/leave animation of the spinner
        this.renderer.setElementStyle(
          this.spinnerElement.nativeElement,
          'opacity',
          '1'
        )
        this.renderer.setElementStyle(
          this.spinnerElement.nativeElement,
          'height',
          '5'
        )
      })
    }
    if (event instanceof NavigationEnd) {
      this._hideSpinner()
    }
    // Set loading state to false in both of the below events to
    // hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this._hideSpinner()
    }
    if (event instanceof NavigationError) {
      this._hideSpinner()
    }
  }

  private _hideSpinner(): void {
    // We wanna run this function outside of Angular's zone to
    // bypass change detection,
    this.ngZone.runOutsideAngular(() => {
      // For simplicity we are going to turn opacity on / off
      // you could add/remove a class for more advanced styling
      // and enter/leave animation of the spinner
      this.renderer.setElementStyle(
        this.spinnerElement.nativeElement,
        'opacity',
        '0'
      )
    })
  }

  
  ngAfterViewInit() {
    $('.navbar-collapse ul li a').click(function() {
          /* always close responsive nav after click */
          $('.navbar-toggler:visible').click();
      });

      $(document).ready(function() {
        $('#closeButton').on('click', function(e) { 
            $('#comp-multi-choose').remove(); 
        });
    });
  }


  getPortalInfo(){
    if(localStorage.getItem(emiGlobals.portalInfo)&&localStorage.getItem(emiGlobals.portalInfo)!='undefined'){
      this.portalInfo = JSON.parse(localStorage.getItem(emiGlobals.portalInfo));
    }
    if(localStorage.getItem(emiGlobals.portalMenu)&&localStorage.getItem(emiGlobals.portalMenu)!='undefined'){
      this.menu = JSON.parse(localStorage.getItem(emiGlobals.portalMenu));
    }
  }

  navigate(){
       window.location.href=this.portalInfo.logoclick_url;
  }

  swipeEvent(e){
    if (e.direction == 2) {
      this.showHideNav();
    }
  }

  showHideNav(){
     this.show_nav =! this.show_nav ;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/emi-nav/emi-nav.component.ts